module.exports = __webpack_public_path__ + "img/1546102942.588c2f76.jpg";